import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'app-azure-marketplace-error',
  templateUrl: './azure-marketplace-error.component.html',
  styleUrls: ['./azure-marketplace-error.component.scss'],
  standalone: false,
})
export class AzureMarketplaceErrorComponent implements OnInit {
  errorDescription: string = null

  constructor(
    public uiService: UiService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.errorDescription = this.activatedRoute.snapshot.queryParamMap.get('error_description')
  }
}
